import React from 'react';

import { IIconProps, TIconType } from '../interface';

const ImportIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<g clipPath='url(#clip0_12518_139570)'>
				<path
					d='M7 8L12 3L17 8'
					stroke={props?.color || '#2E2E6B'}
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M12 17L12 3'
					stroke={props?.color || '#2E2E6B'}
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M20 20L4 20'
					stroke={props?.color || '#2E2E6B'}
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</g>
			<defs>
				<clipPath id='clip0_12518_139570'>
					<rect
						fill='white'
						height='24'
						width='24'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default ImportIcon;
